<template>
  <div class="first-screen">
    <video
      ref="videoBg"
      class="video-bg"
      autoplay
      muted
      loop
      playsinline
      preload="auto"
      poster="@/assets/video/214405.jpg"
      src="https://devdatas.oss-cn-hangzhou.aliyuncs.com/ketech-gsgw/WeChat_20250530150607.mp4"
    ></video>
    <div class="back-filter"></div>
    <div class="scroll-wrapper">
      <div
        class="scroll-list-wrapper"
        :style="{ width: wrapperWidth, left: left }"
      >
        <div class="scroll-item" :style="{ width: width + 'px' }">
          <div class="first-screen-content">
            <div
              class="title"
              :class="{
                show: titleShow
              }"
              @transitionend="handleTitleTransitionEnd"
            >
              反诈中心解决方案
            </div>
            <div
              class="description"
              :class="{
                show: descriptionShow
              }"
              @transitionend="handleDescriptionTransitionEnd"
            >
              满足预警宣防、侦查打击、行业联动等业务闭环的侦查需求，遏制电信网络诈骗犯罪案件高发态势。
            </div>
            <div
              class="to-detail-button"
              :class="{
                show: buttonShow
              }"
              @click="toSolutionDetail(1)"
            >
              查看详情
            </div>
          </div>
        </div>
        <div class="scroll-item" :style="{ width: width + 'px' }">
          <div class="first-screen-content">
            <div class="title show">反诈联盟解决方案</div>
            <div class="description show">
              公安机关牵头，银行、运营商等部门密切协作，实现反诈联盟成员的数据共享和业务协同。
            </div>
            <div class="to-detail-button show" @click="toSolutionDetail(3)">
              查看详情
            </div>
          </div>
        </div>
        <div class="scroll-item" :style="{ width: width + 'px' }">
          <div class="first-screen-content">
            <div class="title show">侦查中心解决方案</div>
            <div class="description show">
              具有案件研判、信息收集分析、跨部门协作、技术支撑等能力；支持省市县三级侦查中心的建设。
            </div>
            <div class="to-detail-button show" @click="toSolutionDetail(2)">
              查看详情
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="radio-group">
      <div
        v-for="item in 3"
        :key="item"
        class="radio-item"
        :class="{ active: current === item }"
        @click="handleScroll(item)"
      >
        <div class="radio-border"></div>
        <div class="radio-dot"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FirstScreen',
  props: {
    firstScreen: {
      type: Number,
      default: 1080
    }
  },
  data() {
    return {
      current: 1,
      increment: 1,
      titleShow: false,
      descriptionShow: false,
      buttonShow: false,
      width: 0,
      timeout: null,
      delay: 6000
    }
  },
  computed: {
    wrapperWidth() {
      return this.width * 3 + 'px'
    },
    left() {
      return -this.width * (this.current - 1) + 'px'
    }
  },
  methods: {
    toSolutionDetail(id) {
      this.$router.push({
        path: `/solution/${id}`
      })
    },
    handleTitleTransitionEnd() {
      this.descriptionShow = true
    },
    handleDescriptionTransitionEnd() {
      this.buttonShow = true
    },
    handleScroll(id) {
      clearTimeout(this.timeout)
      if (id) {
        this.current = id
      } else {
        if (this.current === 3) {
          this.increment = -1
        } else if (this.current === 1) {
          this.increment = 1
        }
        this.current += this.increment
      }
      this.timeout = setTimeout(this.handleScroll, this.delay)
    },
    resize() {
      this.width = this.$el.clientWidth
    }
  },
  mounted() {
    setTimeout(() => {
      this.titleShow = true
    }, 300)
    this.timeout = setTimeout(() => {
      this.handleScroll()
    }, this.delay)
    window.addEventListener('resize', this.resize)
    this.$nextTick(() => {
      this.resize()
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize)
    clearInterval(this.timeout)
  }
}
</script>
<style lang="less" scoped>
.first-screen {
  position: relative;
  width: 100%;
  height: 100vh;
  min-height: 500px;
  overflow: hidden;
  .video-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover; // 确保视频覆盖整个区域
    z-index: 1; // 确保视频在内容之下
  }
  .back-filter {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: radial-gradient(
      ellipse at center,
      #1a1b1633 0%,
      #1a1b16cc 100%
    );
    // background: #1a1b1677;
    z-index: 2;
  }
  .scroll-wrapper {
    position: relative;
    height: 100%;
    overflow: hidden;
    .scroll-list-wrapper {
      position: relative;
      height: 100%;
      transition: left 0.5s;
      .scroll-item {
        height: 100%;
        float: left;
      }
    }
  }
  .first-screen-content {
    position: relative;
    top: 50%;
    margin: 0 auto;
    max-width: 1200px;
    transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    z-index: 3;
    .title {
      font-family: SourceHanSansCN;
      font-weight: 700;
      font-size: 48px;
      line-height: 64px;
      letter-spacing: 8px;
      text-align: center;
      vertical-align: middle;
      color: transparent;
      -webkit-text-fill-color: transparent;
      background: linear-gradient(
        180deg,
        #ffffff 81.5%,
        rgba(240, 232, 204, 0.4) 100%
      );
      background-clip: text;
      -webkit-background-clip: text;
      text-shadow: 0px 2px 6px #00000014, 0px 6px 2px #0000000f;
      opacity: 0;
      transform: translateY(50px);
      transition: all 0.3s;
      &.show {
        opacity: 1;
        transform: translateY(0px);
      }
    }
    .description {
      margin: 40px auto 0;
      max-width: 835px;
      padding: 0 20px;
      font-weight: 500;
      font-size: 24px;
      line-height: 56px;
      letter-spacing: 0%;
      text-align: center;
      vertical-align: middle;
      color: #f7f7f7;
      text-shadow: 0px 2px 6px #00000014, 0px 6px 2px #0000000f;
      opacity: 0;
      transform: translateY(50px);
      transition: all 0.3s;
      &.show {
        opacity: 1;
        transform: translateY(0px);
      }
    }
    .to-detail-button {
      margin: 200px auto 0;
      width: 266px;
      height: 57px;
      border-radius: 8px;
      cursor: pointer;
      background-color: #ff1e3d;
      color: white;
      font-size: 24px;
      line-height: 57px;
      text-align: center;
      opacity: 0;
      transform: translateY(50px);
      transition: all 0.3s;
      &.show {
        opacity: 1;
        transform: translateY(0px);
      }
      &::after {
        content: '';
        position: relative;
        display: inline-block;
        margin-left: 8px;
        height: 10px;
        width: 10px;
        border-width: 2px 2px 0 0;
        border-style: solid;
        border-color: white;
        border-radius: 3px;
        transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        vertical-align: middle;
      }
      &:hover {
        box-shadow: 2px 2px 6px 0px #00000050;
      }
    }
  }
  .radio-group {
    position: absolute;
    bottom: 72px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
    .radio-item {
      position: relative;
      display: inline-block;
      margin-right: 24px;
      width: 32px;
      height: 32px;
      cursor: pointer;
      &:last-child {
        margin-right: 0;
      }
      &.radio-item:not(.active):hover {
        .radio-dot {
          background-color: #d2153d;
        }
      }
      &.active {
        .radio-border {
          opacity: 1;
          width: 32px;
          height: 32px;
        }
        .radio-dot {
          background-color: #d2153d;
        }
      }
      .radio-border {
        position: absolute;
        top: 50%;
        left: 50%;
        height: 14px;
        width: 14px;
        border-radius: 50%;
        border: 1px dashed #d2153d;
        transform: translate(-50%, -50%);
        opacity: 0;
        border-radius: 50%;
        transition: all 0.3s;
      }
      .radio-dot {
        position: absolute;
        left: 50%;
        top: 50%;
        height: 12px;
        width: 12px;
        border-radius: 50%;
        background-color: #fff;
        transform: translate(-50%, -50%);
        transition: all 0.3s;
      }
    }
  }
}
@media screen and (min-width: 767px) and (max-width: 900px) {
  .first-screen {
    .first-screen-content {
      .title {
        font-size: 80px;
      }
      .description {
        font-size: 28px;
      }
    }
    .radio-group {
      bottom: 36px;
    }
  }
}

@media screen and (min-width: 768px) and (max-width: 1199px) {
  /* 中等屏幕样式 */
}

/* 平板端 */
@media screen and (min-width: 768px) and (max-width: 1024px) {
  /* 平板样式 */
}

/* 移动端 */
@media screen and (max-width: 767px) {
  /* 手机样式 */
  .first-screen {
    .first-screen-content {
      .title {
        font-size: 50px;
      }
      .description {
        margin: 20px auto 0;
        font-size: 24px;
      }
    }
    .radio-group {
      bottom: 36px;
    }
  }
}

@media screen and (max-width: 480px) {
  /* 小手机样式 */
  .first-screen {
    .first-screen-content {
      .title {
        font-size: 32px;
      }
      .description {
        font-size: 22px;
      }
    }
    .radio-group {
      bottom: 36px;
    }
  }
}

@keyframes grow {
  0% {
    opacity: 1;
    width: 12px;
    height: 12px;
  }
  100% {
    opacity: 1;
    width: 32px;
    height: 32px;
  }
}
</style>
